export const collaboratorsLocale = {
    title: 'Cộng tác viên',
    code: "code giới thiệu",
    link: "link",
    number_people_invited: "số lượng người dùng đã mời",
    level: "Level",
    balance_received: "số dư có chưa nhận",
    register_withdraw: "đăng ký rút tiền",
    list_user_invite: 'danh sách user invite',
    search: 'search',
    stt: 'STT',
    time: 'Thời gian',
    mail: 'mail',
    kyc: 'kyc',
    withdrawal_history: 'lịch sử rút tiền',
    amount: 'số lượng',
    token_type: 'Loại token',
    status: 'trạng thái',
    register_title: 'Đăng ký trở thành cộng tác viên',
    register_content: 'Với việc nhấn nút xác nhận bên dưới, bạn sẽ đồng ý tham gia chương trình cộng tác viên của AIS.',
    confirm_register: 'xác nhận',
    close_register: 'hủy bỏ',
    withdraw_all: 'Rút toàn bộ',
    withdraw_landmark: 'Rút theo mốc',
    money: 'Số tiền',
    money_remaining: 'Còn lại',
    withdrawal_fee: 'Phí rút',
    bonus_draw_milestone: 'mốc rút thưởng ( người giới thiệu ) ',
    withdraw_content: 'Người dùng có thể lựa chọn rút tiền dựa theo mốc level đang có hoặc theo toàn bộ số tiền đã kiếm được. Khi rút tiền thì cấp độ và số lượng giới thiệu sẽ bị reset lại. Rút toàn bộ sẽ phải mất một khoản phí là 2000 STN-A.',
    unknown_error: 'Đã có lỗi xảy ra, vui lòng thử lại sau.',
    oops: 'Rất tiếc!',
    ok: 'OK',
};
